import { render, staticRenderFns } from "./places_list.vue?vue&type=template&id=569b2a06&scoped=true&"
import script from "./places_list.vue?vue&type=script&lang=js&"
export * from "./places_list.vue?vue&type=script&lang=js&"
import style0 from "./places_list.vue?vue&type=style&index=0&id=569b2a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569b2a06",
  null
  
)

export default component.exports